<template>
  <div
    id="reports"
    :style="[
      $vuetify.breakpoint.xs ? { padding: '30px' } : { padding: '50px' },
    ]"
  >
    <b-overlay :show="process" no-wrap>
      <template v-slot:overlay>
        <img
          src="../assets/images/logo anim.svg"
          width="100px"
          height="100px"
        />
      </template>
    </b-overlay>
    <h4>Reports</h4>
    <div class="mt-5" id="updates" v-if="classes.length">
      <h5>Updates</h5>
      <v-card flat class="mt-5">
        <v-tabs background-color="rgba(0,0,0,0.05)" v-model="tab" grow>
          <v-tab @click="get(classs)" v-for="classs in classes" :key="classs">{{
            classs
          }}</v-tab>
        </v-tabs>
        <div style="max-height: 250px; overflow: scroll">
          <v-card flat v-if="updates.length">
            <v-list>
              <div v-for="update in updates" :key="update.update">
                <v-list-item>
                  <b>{{ update.timestamp | formatDate2 }}</b>
                  : {{ update.update }}
                </v-list-item>
                <v-divider class="mt-0 mb-0"></v-divider>
              </div>
            </v-list>
          </v-card>
          <div v-else>
            <v-list-item>No updates available for this class</v-list-item>
          </div>
        </div>
      </v-card>
    </div>
    <div class="mt-7" id="endline" v-if="endline.length">
      <h5>Endline Reports</h5>
      <v-card v-for="item in endline" :key="item.id" class="mt-5">
        <v-card-title>{{ item.data.name }}</v-card-title>
        <v-card-subtitle
          >Uploaded: {{ item.data.timestamp | formatDate }}</v-card-subtitle
        >
        <v-card-text class="mt-n3">
          <router-link target="_blank" :to="`/reports/endline/${item.id}`"
            >Report</router-link
          >
        </v-card-text>
      </v-card>
    </div>
    <div class="mt-7" id="baseline" v-if="baseline.length">
      <h5>Baseline Reports</h5>
      <v-card v-for="item in baseline" :key="item.id" class="mt-5">
        <v-card-title>{{ item.data.name }}</v-card-title>
        <v-card-subtitle
          >Uploaded: {{ item.data.timestamp | formatDate }}</v-card-subtitle
        >
        <v-card-text class="mt-n3">
          <router-link target="_blank" :to="`/reports/baseline/${item.id}`"
            >Report</router-link
          >
        </v-card-text>
      </v-card>
    </div>
    <div class="mt-7" id="yearend" v-if="yearend.length">
      <h5>Year-End Reports</h5>
      <v-card v-for="item in yearend" :key="item.id" class="mt-5">
        <v-card-title>{{ item.data.name }}</v-card-title>
        <v-card-subtitle
          >Uploaded: {{ item.data.timestamp | formatDate }}</v-card-subtitle
        >
        <v-card-text class="mt-n3">
          <a target="_blank" :href="rubric[item.data.name]">Rubric</a>
          <router-link
            target="_blank"
            class="ml-2"
            :to="`/reports/yearend/${item.id}`"
            >Report</router-link
          >
        </v-card-text>
      </v-card>
    </div>
    <div class="mt-7" id="assignment-reports" v-if="assignmentReports.length">
      <b-sidebar
        id="assignment-reports-guide-sidebar"
        title="Guide"
        right
        shadow
      >
        <div class="p-3">
          <p>
            These reports contain the grades for the assignments submitted by
            student.
          </p>
        </div>
      </b-sidebar>
      <b-tooltip target="assignment-reports-guide-tooltip" triggers="hover"
        >Click to toggle guide for report type</b-tooltip
      >
      <h5>
        Assignment Reports&nbsp;
        <b-button
          size="sm"
          class="mb-1 ml-1"
          id="assignment-reports-guide-tooltip"
          v-b-toggle.assignment-reports-guide-sidebar
        >
          <b-icon-info-circle></b-icon-info-circle>
        </b-button>
      </h5>
      <table class="table" id="assignment-reports-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Class</th>
            <th>Grade</th>
            <th>Comments</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="report in assignmentReports" v-bind:key="report.name">
            <td>{{ report.name }}</td>
            <td>{{ report.class }}</td>
            <td>{{ report.grade }}</td>
            <td>{{ report.comments }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!assignmentReports.length && !yearend.length" class="mt-3">
      There are no reports to show.
    </div>
  </div>
</template>

<script>
// TODO 1 report templates
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");
import moment from "moment";

export default {
  data() {
    return {
      tab: null,
      sel: null,
      process: true,
      assignmentReports: [],
      yearend: [],
      classes: [],
      updates: [],
      baseline: [],
      endline: [],
      rubric: {
        "Public Speaking 2":
          "https://firebasestorage.googleapis.com/v0/b/filestorage-a7fb3.appspot.com/o/Resources%2FPublic%20Speaking%20Rubric.pdf?alt=media&token=498dcb2f-bad5-43bb-832e-da5e805c9820",
        "Public Speaking":
          "https://firebasestorage.googleapis.com/v0/b/filestorage-a7fb3.appspot.com/o/Resources%2FPublic%20Speaking%20Rubric.pdf?alt=media&token=498dcb2f-bad5-43bb-832e-da5e805c9820",
      },
    };
  },
  computed: {
    ...mapState(["currentUser", "userProfile", "promise"]),
  },
  created: async function () {
    await this.promise;
    this.classes = this.userProfile.classes;
    this.get(this.classes[0]);
    this.getReports();
  },
  methods: {
    get(c) {
      if (c == this.sel) {
        return;
      }
      this.sel = c;
      this.updates = [];
      fb.db
        .collection("updates")
        .where("student", "==", this.userProfile.email)
        .where("class", "==", c)
        .orderBy("timestamp", "desc")
        .get()
        .then((qs) => {
          qs.forEach((doc) => {
            this.updates.push(doc.data());
          });
        });
    },
    getReports() {
      //this works here
      const vue = this;
      fb.db
        .collection("reports")
        .where("student", "==", this.currentUser.email)
        .orderBy("timestamp", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            if (data.type == "assignment") {
              const docRef = fb.db.collection("reportReceipts").doc(doc.id);
              docRef.delete();
              if (this.userProfile.classes.includes(data.class)) {
                vue.assignmentReports.push(data);
              }
            } else if (data.type == "year-end") {
              const temp = { id: doc.id, data };
              vue.yearend.push(temp);
            } else if (data.type == "baseline") {
              const temp = { id: doc.id, data };
              vue.baseline.push(temp);
            } else if (data.type == "endline") {
              const temp = { id: doc.id, data };
              vue.endline.push(temp);
            }
          });
        })
        .then(() => {
          vue.process = false;
        });
    },
  },
  filters: {
    formatDate(v) {
      return moment(v.toDate()).format("MMMM Do YYYY");
    },
    formatDate2(v) {
      return moment(v.toDate()).format("dddd, MMMM Do");
    },
  },
};
</script>